module.exports = (__parcel__import__("6fiRO")).then(() => parcelRequire('2geSQ'));